import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const customerManagementSlide = createSlice({
    name: "customerManagement",
    initialState: {
        page: 0,
        pageCount: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        summaryData: null,
    },
    reducers: {
        doGetCustomerManagementListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
			state.totalRow = action.payload?.total_row;
        },
        doGetCustomerManagementListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
			state.totalRow = 0;
        },
        doGetCustomerManagementSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetCustomerManagementSummaryFail: (state, action) => {
            state.summaryData = null;
        },
        doGetCustomerManagementDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetCustomerManagementDetailFail: (state, action) => {
            state.detailData = null;
        },
        doAddCustomerManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddCustomerManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateCustomerManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateCustomerManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },
        resetCustomerManagementStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
            state.detailData = null;
			state.errorDetailData = null;
        },
    },
});

export const doGetCustomerManagementList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/customer-management?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetCustomerManagementListSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerManagementListFail(error.response));
    }
};

export const doGetCustomerManagementSummary = () => async (dispatch) => {
    try {
        const url = `/api/admin/customer-management/summary`;

        const response = await axios.get(url);
        dispatch(doGetCustomerManagementSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerManagementSummaryFail(error.response));
    }
};

export const doGetCustomerManagementDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/customer-management/${param.customer_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetCustomerManagementDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetCustomerManagementDetailFail(error.response));
    }
};

export const doAddCustomerManagement = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/customer-management`;

        const response = await axios.post(url, param);
        dispatch(doAddCustomerManagementSuccess(response.data));
    } catch (error) {
        dispatch(doAddCustomerManagementFail(error.response));
    }
};

export const doUpdateCustomerManagement = (param, customerId) => async (dispatch) => {
    try {
        const url = `/api/admin/customer-management/${customerId}`;

        const response = await axios.put(url, param);
        dispatch(doUpdateCustomerManagementSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateCustomerManagementFail(error.response));
    }
};


export const resetCustomerManagementState = () => async (dispatch) => {
    dispatch(resetCustomerManagementStateSuccess(false));
 };

export const { 
    doGetCustomerManagementListSuccess,
    doGetCustomerManagementListFail,
    doGetCustomerManagementSummarySuccess,
    doGetCustomerManagementSummaryFail,
    doGetCustomerManagementDetailSuccess,
    doGetCustomerManagementDetailFail,
    doAddCustomerManagementSuccess,
    doAddCustomerManagementFail,
    doUpdateCustomerManagementSuccess,
    doUpdateCustomerManagementFail,
    resetCustomerManagementStateSuccess,
} = customerManagementSlide.actions;

export const getCustomerManagementList = (state) => state.customerManagement?.listData;
export const getCustomerManagementSummary = (state) => state.customerManagement?.summaryData;
export const getCustomerManagementListPage = (state) => state.customerManagement?.page;
export const getCustomerManagementListPageCount = (state) => state.customerManagement?.pageCount;
export const getCustomerManagementListTotal = (state) => state.customerManagement?.totalRow;
export const getCustomerManagementDetail = (state) => state.customerManagement?.detailData;
export const getCustomerManagementErrorDetailData = (state) => state.customerManagement?.errorDetailData;
export const getAddCustomerManagementSuccess = (state) => state.customerManagement?.success;
export const getAddCustomerManagementFail = (state) => state.customerManagement?.fail;
export const getAddCustomerManagementResponseData = (state) => state.customerManagement?.responseData;

export default customerManagementSlide.reducer;
